
/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import PurchaseModal from '../../components/modals/purchaseModal';
import APILoader from '../../components/other/api-loader';
import NoDataFound from '../../components/other/nothing';

/*Services*/
import devconfig from '../../config/config.js';
import APIGet from '../../services/apiCall/get';
import APIPost from '../../services/apiCall/post';

/*Assets*/
import OfferBanner from '../../assets/images/ofr-banner4.jpg';
import OfferLogo from '../../assets/images/purchase-logo.png';
import GetURLVar from '../../services/getParams/get-url-var';


class AdsPlans extends Component {
  constructor(props){
    super(props);
    this.state = {
      apiLoading: true,
      tabIndex: 1,
      data: null,
      vendorPlans: [],
      plansTab: 1
    }
  }
   componentDidMount() {
    this.getVendorPlans();
    this.getAllPlans();
    GetURLVar().then(function(query){
      if(query.new){
        this.setState({tabIndex: 2});
      }
    }.bind(this))
  }

  getVendorPlans(page_num=1, status){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+ 'plan/my-plan';
    var data = JSON.stringify({ page_num: page_num, status: status });
    APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        console.log(response.data);
        this.setState({ vendorPlans: response.data,apiLoading: false });
      }
    }.bind(this))
  }

  getAllPlans(){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+ 'plan/list-all';
    // var data = JSON.stringify({type: 2});
    APIGet(url).then(function(response){
      if(response.status == "ok"){
        this.setState({ data: response.data, baseData: [...response.data],apiLoading: false });
      }
    }.bind(this))
  }

  keyDownHandler(e) {
    if (e.keyCode == 13) this.submitSearch();
  }

  submitSearch() {
    this.setState({ apiLoading: true });
    if (this.state.query && this.state.baseData && this.state.baseData.length) {
      let query = this.state.query.toLowerCase();
      let base = this.state.baseData;
      let out = [];
      base.forEach(item => {
        if (item.name && item.name.toLowerCase().includes(query)) out.push(item);
      });
      this.setState({ data: out });
    }
    else if (this.state.baseData && this.state.baseData.length) {
      let out = [...this.state.baseData];
      this.setState({ data: out });
    }
    this.setState({ apiLoading: false });
  }

  // getAllPlans(){
  //   this.setState({apiLoading: true});
  //   var url = devconfig.vendor+ 'plan/list';
  //   var data = JSON.stringify({type: 2});
  //   APIPost(url, data).then(function(response){
  //     if(response.status == "ok"){
  //       console.log(response.data);
  //       this.setState({ data: response.data,apiLoading: false });
  //     }
  //   }.bind(this))
  // }

  tabItemClick(tempItem){
    this.setState({tabIndex: tempItem});
  }

  selectChange = async (filterBy) => {
    await this.setState({filterBy: filterBy});
    this.getVendorPlans(1, filterBy.value)
  }


  render() {

     const filterBy = [
      { value: null, label: 'All' },
      { value: 1, label: 'Ongoing' },
      { value: 2, label: 'Completed' },
    ]

    return (
      <div>
        <div className="e-main-content e-vendor-table">
            <h2 className="e-page-head">Ad's Plans</h2>
            {/*<div className="row">
              <div className="col-lg-12">
                <img src={OfferBanner} className="e-ofer-banner mr-3" alt="Offer Banner"/>
              </div>
            </div>*/}
            <div className="row mt-2">
              <div className="col-lg-6 e-vendor-tab-link-wrap e-ads-wrap">

                {
                  this.state.tabIndex === 1 ?
                    <span className="e-active">My Plans</span>
                  :
                    <span onClick={this.tabItemClick.bind(this, 1)}>My Plans</span>
                }

                {
                  this.state.tabIndex === 2 ?
                    <span className="e-active">Purchase new plan</span>
                  :
                    <span onClick={this.tabItemClick.bind(this, 2)}>Purchase new plan</span>
                }

              </div>
            </div>

            {
              this.state.tabIndex === 1 ?


                <div>
                  {/* <div className="row mt-4 pt-2">
                    <div className="col-lg-3">
                      <h6 className="e-filter">Filter by</h6>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-2">
                      <SelectBox defaultValue={this.state.filterBy} options={filterBy} selectchange={this.selectChange}/>
                    </div>
                  </div> */}

                  {
                    this.state.apiLoading ?
                      <APILoader/>
                    :
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="accordion pt-3" id="accordionExample">
                          {
                            this.state.vendorPlans.map((plan, index)=>{
                              return(
                                <div className={index==0 ? "card e-vendor-category-list" : "card e-vendor-category-list mt-3"}>
                                  <div className="card-header" id="headingOne">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <button  className={this.state.activeAccordion === index ? "btn btn-link e-faq" : "btn btn-link e-faq collapsed" } type="button" data-toggle="collapse" onClick={(tempVal) => this.setState({activeAccordion: index})} data-target={"#collapseOne"+index} aria-expanded={this.state.activeAccordion === index ? "true" : "false" } aria-controls="collapseOne">
                                          <div className="row pt-1">
                                            <div className="col-lg-6 col-md-6 co-sm-6 col-6  pl-0">

                                              <h6 className="text-left">Plan type:</h6>
                                              <p className="text-left">{plan.type}</p>
                                            </div>

                                            <div className="col-lg-2 col-md-6 col-sm-6 col-6 text-left">
                                              <h6>Plan Name:</h6>
                                              <p className="">{plan.plan_name}</p>
                                            </div>
                                            <div className="col-lg-2 col-md-6 col-sm-6 col-6 text-left pl-sm-0">
                                              <h6>Purchased on:</h6>
                                              <p className="">{plan.purchased_on}</p>
                                            </div>
                                            <div className="col-lg-2 col-md-6 col-sm-6 col-6 text-left">
                                              <h6>Total amount:</h6>
                                              <p className="">INR {plan.total}</p>
                                            </div>
                                            {/* <div className="col-lg-2 text-left">
                                              <h6>Status:</h6>
                                              <p className="e-ongoing">{plan.status}</p>
                                            </div> */}
                                          </div>
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  <div id={"collapseOne"+index} className={this.state.activeAccordion === index ? "collapse show" : "collapse"} aria-labelledby="headingOne" data-parent="#accordionExample">
                                    <div className="card-body">
                                      <div className="e-border-accordion pt-3">
                                        <div className="row mt-2 mb-4">
                                          <div className="col-lg-8 col-md-8 col-sm-8 col-8">
                                            <h6>Features </h6>
                                          </div>
                                          <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                                            <h6>Time Left</h6>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="e-border-accordion pt-2">
                                        <div className="row my-3">
                                          <div className="col-lg-8 col-md-8 col-sm-8 col-8">
                                          {
                                            plan.features.map((feature, index2)=>{
                                              return(
                                                <p>{feature.ads_location_name}</p>
                                              )
                                            })
                                          }
                                          </div>
                                          <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                                            {
                                              plan.features.map((feature, index2)=>{
                                                if(plan.type_id==1){
                                                  var validityType = feature.validity_type===1? "Days" : feature.validity_type===2? "Months" : feature.validity_type===3? "Years" : "Days";
                                                }else{
                                                  var validityType = " Hours" 
                                                }
                                                return(
                                                  <p>{feature.time_left} {validityType}</p>
                                                )
                                              })
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                            })
                          }
                          </div>
                        </div>
                      </div>
                  }
                  


                </div>
              :
                null
            }

            {
              this.state.tabIndex === 2 ?
                <div>
                {
                 this.state.data ?
                  <div>
                    <div className="row mb-4 mt-5">
                      <div className="col-lg-12">
                        <span className={this.state.plansTab == 1 ? "e-tab-head e-active" : "e-tab-head"} onClick={()=>this.setState({plansTab: 1, query: ""},()=>this.submitSearch())}>Membership plan</span>
                        <span className={this.state.plansTab == 2 ? "e-tab-head e-active" : "e-tab-head"} onClick={()=>this.setState({plansTab: 2, query: ""},()=>this.submitSearch())}>Advertisement plan</span>
                      </div>
                    </div>
                    <div className="row">
                    <div className="col-lg-4 pt-3">
                      <div className="e-search-wrap e-category-search w-100 position-relative">
                        <input className="e-search-input w-100" placeholder="Search with plan name" value={this.state.query} type="text" onChange={(e) => this.setState({ query: e.target.value })} onKeyDown={this.keyDownHandler.bind(this)} required />
                        {
                          this.state.query && this.state.query.length ?
                            <div className="e-search-btn position-absolute" onClick={this.submitSearch.bind(this)}></div>
                            :
                            null
                        }
                      </div>
                    </div>
                    </div>
                      {
                        this.state.plansTab == 1 ?
                          <div className="row mt-4 pt-2">
                            {
                              this.state.data.map((plan ,index) => {
                                var tempId= "e-plan-modal"+plan.id;
                                var tempSelector= "#e-plan-modal"+plan.id;
      
                                if(plan.type_id == 1){
                                  return(
                                    <div className="col-lg-4">
                                      <div className="e-plan-wrap-outer">
                                        <div className={this.state.viewMore == index ? "e-plan-wrap e-large" : "e-plan-wrap"}>
                                          <div className="e-plan-content e-plan-one">
                                            <h1 className="py-4 mb-0"><span className="e-symbol">₹</span>{plan.offer_price}<span className="pl-2"><strike>₹{plan.price}</strike></span></h1>
                                            {
                                              this.props.type==1?
                                                <h5  className="py-4 mb-0"><span className="e-symbol">₹</span>{plan.emi_amount}/month</h5>
                                              :
                                                null
                                            }
                                            <h2 className="" style={{color: plan.color}}>{plan.name}</h2>
                                            <p className="pt-2">{plan.description}</p>

                                            <div className="e-plan-ad-list-wrap">
                                              <ul>
                                                {
                                                  plan.features.map((item, index2)=>{
                                                    var validityType = item.validity_type===1? "Days" : item.validity_type===2? "Months" : item.validity_type===3? "Years" : "Days";
                                                    var contentTypes = "";
                                                    if(item.ads_content_ids.length==3){
                                                      contentTypes = "Images, Videos & Gifs"
                                                    }else{
                                                      if(item.ads_content_ids.includes(1)){
                                                        contentTypes = "Images"
                                                      }
                                                      if(item.ads_content_ids.includes(2)){
                                                        if(contentTypes.length){
                                                          contentTypes = contentTypes + "& Videos"
                                                        }else{
                                                          contentTypes = "Videos"
                                                        }
                                                      }
                                                      if(item.ads_content_ids.includes(3)){
                                                        if(contentTypes.length){
                                                          contentTypes = contentTypes + "& Gifs"
                                                        }else{
                                                          contentTypes = "Gifs"
                                                        }
                                                      }
                                                    } 
                                                    return(
                                                      <li><span style={{background: plan.color}}></span>{item.ads_location} - {item.validity} {validityType} ({contentTypes})</li>
                                                    )
                                                  })
                                                
                                                }
                                              </ul>
                                            </div>


                                            <h6 className="pb-3 pt-4">{plan.additional_info && plan.additional_info.map((feature, index3)=>{return(" • " + feature)})}</h6>
                                            <div className="text-center">
                                              {
                                                this.state.viewMore == index ?
                                                  <div className="e-plan-view-more" onClick={() => this.setState({viewMore: null})}>View Less</div>
                                                :
                                                  <div className="e-plan-view-more" onClick={() => this.setState({viewMore: index})}>View More</div>
                                              }
                                            </div>

                                          </div>
                                        </div>
                                        <div className="e-ad-plan-button-wrap text-center">
                                          <div className="col-lg-12">
                                            <button className="e-s-btn e-purchase-btn" type="submit" value="Submit" data-toggle="modal" data-target={tempSelector}>Purchase now</button>
                                          </div>
                                          <PurchaseModal id={tempId} data={plan} paymentSuccess={()=>this.setState({tabIndex: 1})}/>
                                        </div>
                                      </div>

                                    </div>
                                  );
                                }
                                else{
                                  return(
                                    null
                                  )
                                }
                              })
      
                            }
                            </div>
                          :
                            <div className="row mt-4 pt-2">
                              {
                                this.state.data.map((plan,index) => {
                                  var tempId= "e-plan-modal"+plan.id;
                                  var tempSelector= "#e-plan-modal"+plan.id;
        
                                  if(plan.type_id == 2){
                                    return(
                                      <div className="col-lg-4">
                                        <div className="e-plan-wrap-outer">
                                          <div className={this.state.viewMore == index ? "e-plan-wrap e-large" : "e-plan-wrap"}>
                                            <div className="e-plan-content e-plan-one">
                                              <h1 className="py-4 mb-0"><span className="e-symbol">₹</span>{plan.offer_price}<span className="pl-2"><strike>₹{plan.price}</strike></span></h1>
                                              {
                                                this.props.type==1?
                                                  <h5  className="py-4 mb-0"><span className="e-symbol">₹</span>{plan.emi_amount}/month</h5>
                                                :
                                                  null
                                              }
                                              <h2 className="" style={{color: plan.color}}>{plan.name}</h2>
                                              <p className="pt-2">{plan.description}</p>

                                              <div className="e-plan-ad-list-wrap">
                                                <ul>
                                                  {
                                                    plan.features.map((item, index2)=>{
                                                      var validityType = item.validity_type===1? "Days" : item.validity_type===2? "Months" : item.validity_type===3? "Years" : "Days";
                                                      var contentTypes = "";
                                                      if(item.ads_content_ids.length==3){
                                                        contentTypes = "Images, Videos & Gifs"
                                                      }else{
                                                        if(item.ads_content_ids.includes(1)){
                                                          contentTypes = "Images"
                                                        }
                                                        if(item.ads_content_ids.includes(2)){
                                                          if(contentTypes.length){
                                                            contentTypes = contentTypes + "& Videos"
                                                          }else{
                                                            contentTypes = "Videos"
                                                          }
                                                        }
                                                        if(item.ads_content_ids.includes(3)){
                                                          if(contentTypes.length){
                                                            contentTypes = contentTypes + "& Gifs"
                                                          }else{
                                                            contentTypes = "Gifs"
                                                          }
                                                        }
                                                      } 
                                                      return(
                                                        <li><span style={{background: plan.color}}></span>{item.ads_location} - {item.validity} {validityType} ({contentTypes})</li>
                                                      )
                                                    })
                                                  
                                                  }
                                                </ul>
                                              </div>


                                              <h6 className="pb-3 pt-4">{plan.additional_info && plan.additional_info.map((feature, index3)=>{return(" • " + feature)})}</h6>
                                              <div className="text-center">
                                                {
                                                  this.state.viewMore == index ?
                                                    <div className="e-plan-view-more" onClick={() => this.setState({viewMore: null})}>View Less</div>
                                                  :
                                                    <div className="e-plan-view-more" onClick={() => this.setState({viewMore: index})}>View More</div>
                                                }
                                              </div>

                                            </div>
                                          </div>
                                          <div className="e-ad-plan-button-wrap text-center">
                                            <div className="col-lg-12">
                                              <button className="e-s-btn e-purchase-btn" type="submit" value="Submit" data-toggle="modal" data-target={tempSelector}>Purchase now</button>
                                            </div>
                                            <PurchaseModal id={tempId} data={plan} paymentSuccess={()=>this.setState({tabIndex: 1})}/>
                                          </div>
                                        </div>

                                      </div>
                                    );
                                  }
                                  else{
                                    return(
                                      null
                                    )
                                  }
                                  
        
                                })
        
                              }
                            </div>
                        }
                                        
                    </div>
                  :
                    null
                }
                </div>
              :
                null
            }

          </div>
      </div>

    );
  }
}

export default AdsPlans;

// id={tempId} data={item}